import React from 'react';
import pagable from '../hoc/pagable';
export default function Pagination(Origin) {
  return function (props) {
    var pagination = props.pagination;
    var Render = pagination ? pagable(Origin) : Origin;
    return (
      /*#__PURE__*/
      React.createElement(Render, props)
    );
  };
}